import { createTheme } from '@mui/material';
import { frFR } from '@mui/material/locale';

export const lightMuiTheme = createTheme(
    {
        typography: {
            fontFamily: ['Inter', 'Geist Sans', 'SF Pro Text', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
            fontSize: 12,
        },

        palette: {
            mode: 'light',
            primary: { main: '#000' },
            secondary: { main: 'rgb(85, 219, 198)' },
            background: { default: '#fafafa', paper: '#fff' },
        },
        shape: {
            borderRadius: 10,
        },
    },
    frFR
);
